import { Plugin } from 'vue'
import * as Sentry from '@sentry/vue'

const plugin: Plugin = {
  install(app) {
    const dsn = import.meta.env.VITE_SENTRY_DSN

    if (!dsn) {
      console.warn('Sentry DSN is not provided')
      return
    }

    const environment: ImportMetaEnv['VITE_APP_ENV'] = import.meta.env.VITE_APP_ENV || 'development'

    Sentry.init({
      app,
      dsn,
      environment,
      sendDefaultPii: true
    })

  }
}

export default plugin
